// CapTableSelectStep — pick a versioned snapshot (Builder step 2).

import { FolderOpen } from 'lucide-react';
import { useActiveValuation, useStore, useCapTables, useSettings } from '../../store/selectors';
import { EmptyState } from '../common/EmptyState';
import { fmtShares } from '../../format/format';

export function CapTableSelectStep() {
  const active = useActiveValuation();
  const settings = useSettings();
  const entity = settings.activeEntityName ?? active?.entityName ?? 'New Entity';
  const caps = useCapTables(entity);
  const setCapTableForValuation = useStore((s) => s.setCapTableForValuation);
  const setReturnIntent = useStore((s) => s.setReturnIntent);
  const navigate = useStore((s) => s.navigate);
  if (!active) return null;

  return (
    <div className="card">
      <div className="card-title">Cap-Table Selection</div>
      {caps.length === 0 ? (
        <EmptyState
          icon={<FolderOpen size={32} strokeWidth={1.5} />}
          message="No committed cap-table snapshot."
          hint="A valuation references a committed snapshot so results stay reproducible — none exist for this entity yet. Create one on the Cap Table screen."
          action={
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setReturnIntent({ screen: 'builder', valuationId: active.valuationId });
                navigate('capTable');
              }}
            >
              Edit Cap Table
            </button>
          }
        />
      ) : (
        <ul className="stack-2">
          {caps.map((c) => {
            const selected = active.inputs.capTableSnapshot.id === c.id;
            return (
              <li key={c.id}>
                <button
                  type="button"
                  className={`sidebar-item ${selected ? 'active' : ''}`}
                  style={{ width: '100%' }}
                  onClick={() => setCapTableForValuation(active.valuationId, c)}
                >
                  v{c.version} — {c.asOfDate} — {fmtShares(c.instruments.reduce((s, i) => s + i.sharesOutstanding, 0))} shares
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
